import Api from 'utils/api'

export const fetchProjectTemplates = ({ limit, offset, ordering, search }: {
  limit?: number
  offset?: number
  ordering?: string[]
  search?: string
}) =>
  Api.get(['projecttemplates'], { limit, offset, ordering, search })

export const postCopyProjectTemplate = ({ title, department, uuid }: {
  title: string
  department?: number | string
  uuid: string
}) =>
  Api.post(['projecttemplates', uuid, 'copy'], { title, department })

export const postProjectTemplate = (payload: Record<string, unknown>) =>
  Api.post(['projecttemplates'], payload)

export const updateProjectTemplate = (id: string | number, payload: Record<string, unknown>) =>
  Api.patch(['projecttemplates', id], payload)
